import React, { useState } from "react";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  collection,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import { useNavigate } from "react-router-dom";

const TIERS = [
  { label: "2–10 Students ($180 / year)", value: "2-10", price: 180, max: 10 },
  { label: "11–20 Students ($225 / year)", value: "11-20", price: 225, max: 20 },
  { label: "21–30 Students ($250 / year)", value: "21-30", price: 250, max: 30 },
];

const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA",
  "HI","ID","IL","IN","IA","KS","KY","LA","ME","MD",
  "MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ",
  "NM","NY","NC","ND","OH","OK","OR","PA","RI","SC",
  "SD","TN","TX","UT","VT","VA","WA","WV","WI","WY",
  "DC"
];

const inputStyle = {
  width: "100%",
  padding: "12px 14px",
  marginBottom: 14,
  borderRadius: 10,
  border: "1px solid #ddd",
  fontSize: 14,
};

const labelStyle = {
  fontWeight: 600,
  marginBottom: 6,
  display: "block",
};

const sectionStyle = {
  marginBottom: 30,
};

const PurchaseOrderRequest = () => {
  const auth = getAuth();
  const db = getFirestore();
  const storage = getStorage();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    requesterName: "",
    requesterEmail: "",
    requesterPhone: "",

    sirName: "",
    educatorFirst: "",
    educatorLast: "",
    educatorEmail: "",
    state: "",
    grade: "",

    apName: "",
    apEmail: "",
    apPhone: "",

    schoolName: "",
    schoolDistrict: "",
    poNumber: "",

    studentTier: TIERS[0],
    studentCount: "",
    studentNames: "",

    notes: "",
  });

  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!file) return alert("Please upload an approved PO document.");

    setSubmitting(true);

    try {
      const user = auth.currentUser;
      if (!user) throw new Error("Not authenticated");

      const fileRef = ref(
        storage,
        `purchaseOrders/${user.uid}/${Date.now()}_${file.name}`
      );
      
      await uploadBytes(fileRef, file);
      
      // store storage path (not URL)
      const poFilePath = fileRef.fullPath;
      
      // 🔹 BUILD STUDENT NAMES HERE (BEFORE addDoc)
      const namesArray = form.studentNames
        ? form.studentNames.split(",").map((n) => n.trim())
        : [];
      
      const finalStudentNames = Array.from(
        { length: Number(form.studentCount) },
        (_, i) => namesArray[i] || `Student${String(i + 1).padStart(2, "0")}`
      );
      
      // 🔹 NOW write to Firestore
      await addDoc(collection(db, "purchaseOrders"), {
      
  userId: user.uid,

  requester: {
    name: form.requesterName,
    email: form.requesterEmail,
    phone: form.requesterPhone,
  },

  educator: {
    sirName: form.sirName,
    firstName: form.educatorFirst,
    lastName: form.educatorLast,
    email: form.educatorEmail,
    state: form.state,
    grade: form.grade,
  },

  accountsPayable: {
    name: form.apName,
    email: form.apEmail,
    phone: form.apPhone,
  },

  schoolName: form.schoolName,
  schoolDistrict: form.schoolDistrict,
  poNumber: form.poNumber,

  studentTier: form.studentTier.value,
  studentCount: Number(form.studentCount),
  studentNames: finalStudentNames,
  price: form.studentTier.price,

  notes: form.notes,

  // ✅ THIS replaces poFileUrl
  poFilePath,

  status: "pending",
  createdAt: serverTimestamp(),
});


      alert("Purchase Order submitted successfully.");
      navigate("/educator/dashboard");
    } catch (e) {
      console.error(e);
      alert("Failed to submit PO.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ maxWidth: 720, margin: "40px auto", padding: 30, background: "#fafafa", borderRadius: 16 }}>
     <div style={{ textAlign: "center", marginBottom: 20 }}>
  <img
    src="https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2FSBLLogoBlackTM.png?alt=media&token=2f8fde38-b373-4367-9ade-a7b68bae3b6f"
    alt="SBL Logo"
    style={{ height: 90, width: "auto" }}
  />
</div>
     <h2 style={{ marginBottom: 10 }}>School Purchase Order Request</h2>
     <h3 style={{ marginBottom: 10 }}>Print page and email to Team@smartboardlearning.com if necessary</h3>
      <p style={{ marginBottom: 30, color: "#555" }}>
        This purchase order is for <strong>1 educator license</strong>. Student licenses
        are based on the selected tier below.
      </p>

      {/* Requester */}
      <div style={sectionStyle}>
        <h4>Requester Information</h4>
        <input style={inputStyle} placeholder="Full Name" onChange={(e) => setForm({ ...form, requesterName: e.target.value })} />
        <input style={inputStyle} placeholder="Email" onChange={(e) => setForm({ ...form, requesterEmail: e.target.value })} />
        <input style={inputStyle} placeholder="Phone" onChange={(e) => setForm({ ...form, requesterPhone: e.target.value })} />
      </div>

      {/* Educator */}
      <div style={sectionStyle}>
        <h4>Educator (License Holder)</h4>
        <select
  style={inputStyle}
  required
  value={form.sirName}
  onChange={(e) => setForm({ ...form, sirName: e.target.value })}
>
  <option value="">Select Title</option>
  <option value="Mr">Mr.</option>
  <option value="Ms">Ms.</option>
  <option value="Mrs">Mrs.</option>
  <option value="Miss">Miss</option>
</select>

        <input style={inputStyle} placeholder="First Name" onChange={(e) => setForm({ ...form, educatorFirst: e.target.value })} />
        <input style={inputStyle} placeholder="Last Name" onChange={(e) => setForm({ ...form, educatorLast: e.target.value })} />
        <input style={inputStyle} placeholder="Email Address" onChange={(e) => setForm({ ...form, educatorEmail: e.target.value })} />
        <select
  style={inputStyle}
  required
  value={form.state}
  onChange={(e) => setForm({ ...form, state: e.target.value })}
>
  <option value="">Select State</option>
  {US_STATES.map((abbr) => (
    <option key={abbr} value={abbr}>
      {abbr}
    </option>
  ))}
</select>
        <input style={inputStyle} placeholder="Grade Level" onChange={(e) => setForm({ ...form, grade: e.target.value })} />
      </div>

      {/* Accounts Payable */}
      <div style={sectionStyle}>
        <h4>Accounts Payable Contact</h4>
        <input style={inputStyle} placeholder="AP Contact Name" onChange={(e) => setForm({ ...form, apName: e.target.value })} />
        <input style={inputStyle} placeholder="AP Email" onChange={(e) => setForm({ ...form, apEmail: e.target.value })} />
        <input style={inputStyle} placeholder="AP Phone" onChange={(e) => setForm({ ...form, apPhone: e.target.value })} />
      </div>

      {/* Purchase */}
      <div style={sectionStyle}>
        <h4>Purchase Details</h4>
        <input style={inputStyle} placeholder="School Name" onChange={(e) => setForm({ ...form, schoolName: e.target.value })} />
        <input style={inputStyle} placeholder="School District" onChange={(e) => setForm({ ...form, schoolDistrict: e.target.value })} />
        <input style={inputStyle} placeholder="PO Number" onChange={(e) => setForm({ ...form, poNumber: e.target.value })} />

        <select
          style={inputStyle}
          onChange={(e) =>
            setForm({
              ...form,
              studentTier: TIERS.find((t) => t.value === e.target.value),
            })
          }
        >
          {TIERS.map((t) => (
            <option key={t.value} value={t.value}>{t.label}</option>
          ))}
        </select>

        <input
          style={inputStyle}
          type="number"
          placeholder="Exact number of students"
          onChange={(e) => setForm({ ...form, studentCount: e.target.value })}
        />

        <textarea
          style={{ ...inputStyle, minHeight: 80 }}
          placeholder="Student first names (comma separated). Optional."
          onChange={(e) => setForm({ ...form, studentNames: e.target.value })}
        />
      </div>

      <input type="file" accept="application/pdf" onChange={(e) => setFile(e.target.files[0])} />

      <button
        onClick={handleSubmit}
        disabled={submitting}
        style={{
          marginTop: 20,
          width: "100%",
          padding: 14,
          borderRadius: 12,
          border: "none",
          background: "#4f46e5",
          color: "#fff",
          fontSize: 16,
          fontWeight: 600,
        }}
      >
        {submitting ? "Submitting…" : "Submit Purchase Order"}
      </button>
    </div>
  );
};

export default PurchaseOrderRequest;
